import { createBreakpoint } from "styled-components-breakpoint";

const ScreenSize = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
};

const Breakpoint = createBreakpoint({
  xs: ScreenSize.xs,
  sm: ScreenSize.sm,
  md: ScreenSize.md,
  lg: ScreenSize.lg,
  xl: ScreenSize.xl,
});

export default Breakpoint;
export { ScreenSize };
